// Module
var code = `<div class="row">
	<div class="col-12 col-md-6 col-lg-5 scrollable-column">
		<div class="mb-2">
			<scene-content scene="\$ctrl.scene"></scene-content>
		</div>
		<div class="mb-2">
			<scene-player-log id="\$ctrl.scene.id"></scene-player-log>
		</div>
		<div class="mb-2">
			<scene-status id="\$ctrl.scene.id"></scene-status>
		</div>
	</div>
	<div class="col-12 col-md-6 col-lg-7 scrollable-column aVerticalSeparator">
		<div class="mb-2">
			<library-media-labels></library-media-labels>
		</div>
		<div class="mb-2">
			<library-file-media scene="\$ctrl.scene"></library-file-media>
		</div>
		<div class="mb-2">
			<library-social-media scene="\$ctrl.scene"></library-social-media>
		</div>
		<div class="mb-2">
			<library-service-announcements scene="\$ctrl.scene"></library-service-announcements>
		</div>
	</div>
</div>`;
// Exports
export default code;